module.exports = __webpack_public_path__ + "static/comprehensive-image-notification-09d28d1932993a25912196a200e44e75.png";